import React, { Dispatch, DispatchWithoutAction, FC } from 'react';
import { ArrayField } from 'react-hook-form';

import { TEXT_ATTRIBUTE_TYPES } from 'constants/form';
import { EnumerationSelect } from './enumeration-select';
import { RangeFields } from './range-fields';
import { StringEnumerationSelect } from './string-enumeration-select';

interface IAttributeAspectsFieldsProps {
  isDisabled: boolean;
  mnemonics: string;
  fields: Partial<ArrayField<Record<string, string>, 'id'>>[];
  addStringEnumeration: DispatchWithoutAction;
  removeStringEnumeration: Dispatch<number>;
}

export const AttributeAspectsFields: FC<IAttributeAspectsFieldsProps> = (props) => {
  const { mnemonics, isDisabled, ...rest } = props;

  if (mnemonics === 'boolean') {
    return <EnumerationSelect isDisabled={isDisabled} />;
  }

  if (TEXT_ATTRIBUTE_TYPES.includes(mnemonics)) {
    return <StringEnumerationSelect isDisabled={isDisabled} {...rest} />;
  }

  return <RangeFields mnemonics={mnemonics} isDisabled={isDisabled} />;
};
